import { createSelector } from 'reselect'
import { storeKeys } from 'redux-store'
import { getFullProductDetails } from 'tools/product'

const createCombinedSelector = (orderItemsSelector) => [
  orderItemsSelector,
  state => state['@menu'].data
]

const selectFromStoreOrder = state => state[storeKeys.order].storeOrder.data.orderItems

export const createOrderItemsSelector = (selector = selectFromStoreOrder) => createSelector(
  createCombinedSelector(selector),
  (orderItems, menu) => (orderItems || []).filter((item) => !item.isPromotionalItem && item.quantity > 0).map((item) => getFullProductDetails(menu || [], item))
)

export const createPromotionalOrderItemsSelector = (selector = selectFromStoreOrder) => createSelector(
  createCombinedSelector(selector),
  (orderItems, menu) => (orderItems || []).filter((item) => item.isPromotionalItem).map((item) => getFullProductDetails(menu || [], item))
)
